import { defineComponent } from '~/utils/alpine_types'

type Course = {
  driving_license_class_id: number | null
  lesson_type_id: number | null
  end_time: string | null
  product_package_ids: number[]
  lesson_type_subject_ids: number[]
}

type ProductPackage = {
  id: number
  name_with_details: string
  driving_license_class_ids: number[]
}

type LessonType = {
  id: number
  name: string
  driving_license_class_ids: number[]
}

type LessonTypeSubject = {
  id: number
  name: string
  lesson_type_id: number
}

type Args = {
  course: Course
  productPackages: ProductPackage[]
  lessonTypes: LessonType[]
  lessonTypeSubjects: LessonTypeSubject[]
}

export const course = defineComponent((args: Args) => ({
  course: args.course,
  productPackages: args.productPackages,
  lessonTypes: args.lessonTypes || [],
  lessonTypeSubjects: args.lessonTypeSubjects || [],

  get availableProductPackages(): ProductPackage[] {
    const licenseId = this.course.driving_license_class_id
    if (!licenseId) return this.productPackages

    return this.productPackages.filter((productPackage) => {
      const licenseIds = productPackage.driving_license_class_ids
      return !licenseIds.length || licenseIds.includes(licenseId)
    })
  },

  get availableLessonTypes(): LessonType[] {
    if (!this.course.driving_license_class_id) return []

    return this.lessonTypes.filter((lessonType) => this.lessonTypeAvailable(lessonType))
  },

  get availableLessonTypeSubjects(): LessonTypeSubject[] {
    const lessonTypeId = this.course.lesson_type_id
    if (!lessonTypeId) return []

    return this.lessonTypeSubjects.filter((subject) => subject.lesson_type_id === lessonTypeId)
  },

  get selectedLessonType(): LessonType | undefined {
    return this.lessonTypes.find(({ id }) => id === this.course.lesson_type_id)
  },

  init() {
    this.course.end_time = this.course.end_time ? this.course.end_time.split(':', 2).join(':') : null

    this.$watch('course.driving_license_class_id', () => {
      const { selectedLessonType } = this
      if (!selectedLessonType || !this.lessonTypeAvailable(selectedLessonType)) {
        this.course.lesson_type_id = null
      }
    })
  },

  lessonTypeAvailable(lessonType: LessonType): boolean {
    const licenseId = this.course.driving_license_class_id
    return licenseId ? lessonType.driving_license_class_ids.includes(licenseId) : false
  },
}))
